import { render, staticRenderFns } from "./question-edit-v3.vue?vue&type=template&id=9f5022c0&scoped=true"
import script from "./question-edit-v3.vue?vue&type=script&lang=ts"
export * from "./question-edit-v3.vue?vue&type=script&lang=ts"
import style0 from "./question-edit-v3.vue?vue&type=style&index=0&id=9f5022c0&prod&scoped=true&lang=scss"
import style1 from "./question-edit-v3.vue?vue&type=style&index=1&id=9f5022c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5022c0",
  null
  
)

export default component.exports